<template>
  <div :style="currentPositionStyle" class="dragbase whiteboard-note">
    <slot></slot>
  </div>
</template>

<script>
import {interact} from 'interact.js'

export default {
  name: 'DragBase',
  props: {
    w: {type: Number, default: 200},
    h: {type: Number, default: 200},
    x: {type: Number, default: 200},
    y: {type: Number, default: 200},
    id: {type: Number, default: null},
    snapGrid: {type: Boolean, default: false},
    droppable: {type: Boolean, default: false}
  },
  computed: {
    currentPositionStyle () {
      return {
        top: this.currentY + 'px',
        left: this.currentX + 'px',
        width: this.currentW + 'px',
        height: this.currentH + 'px'
      }
    }
  },
  data: function () {
    return {
      currentX: this.x,
      currentY: this.y,
      currentW: this.w,
      currentH: this.h,
      dropzoneId: null,
      resizable: this.$can('update', 'GraphicalView'),
      draggable: this.$can('update', 'GraphicalView')
    }
  },
  watch: {
    snapGrid (newSnap) {
      this.setListener(newSnap)
    },
    droppable () {
      this.setListener(this.snapGrid)
    }
  },
  methods: {
    dragMoveListener (event) {
      // translate the element
      this.currentY += event.dy
      this.currentX += event.dx
      this.$emit('dragmove', this.currentX, this.currentY)
    },
    dragEndListener (event) {
      // keep the dragged position in the data-x/data-y attributes
      if (!this.moveNoteToNewBoard()) {
        this.$emit('dragstop', this.currentX, this.currentY)
      }
    },
    resizeEndListener (event) {
      this.$emit('resizestop',
        this.currentX,
        this.currentY,
        this.currentW,
        this.currentH
      )
    },
    resizeMoveListener (event) {
      this.currentW = event.rect.width
      this.currentH = event.rect.height
      // translate when resizing from top or left edges
      this.currentX += event.deltaRect.left
      this.currentY += event.deltaRect.top
    },
    inertiaStartListener (event) {
    },
    moveNoteToNewBoard () {
    },
    setListener (snapGrid) {
      let self = this
      let snapConfig = snapGrid ? {
        targets: [
          interact.createSnapGrid({x: 20, y: 20})
        ],
        range: Infinity,
        relativePoints: [{x: 0, y: 0}]
      } : null
      let interactObj = interact(this.$el)
        .draggable({
          snap: snapConfig,
          inertia: true,
          // keep the element within the area of it's parent
          restrict: {
            restriction: document.getElementById('whiteboard'),
            endOnly: true,
            elementRect: { top: 0, left: 0, bottom: 1, right: 1 }
          },
          // enable autoScroll
          autoScroll: true,

          // call this function on every dragmove event
          onmove: self.dragMoveListener,
          // call this function on every dragend event
          onend: self.dragEndListener,
          oninertiastart: self.inertiaStartListener
        })
      if (this.resizable) {
        interactObj.resizable({
        // resize from all edges and corners
          edges: { left: true, right: true, bottom: true, top: true },
          snap: snapConfig,
          // keep the edges inside the parent
          restrictEdges: {
            outer: 'parent',
            endOnly: true
          },

          // minimum size
          restrictSize: {
            min: { width: 100, height: 50 }
          },

          inertia: true
        })
          .on('resizemove', self.resizeMoveListener
          ).on('resizeend', self.resizeEndListener)
      }
      if (this.droppable) {
        let noteId = this.id
        interactObj.dropzone({
        // only accept elements matching this CSS selector
          accept: '.whiteboard-note',
          // Require a 75% element overlap for a drop to be possible
          overlap: 'pointer',

          // listen for drop related events:

          ondropactivate: function (event) {
          // add active dropzone feedback
            event.target.classList.add('drop-active')
          },
          ondragenter: function (event) {
            let draggableElement = event.relatedTarget,
              dropzoneElement = event.target

            // feedback the possibility of a drop
            dropzoneElement.classList.add('drop-target')
            draggableElement.classList.add('can-drop')

            self.$store.commit('updateDropOnNoteId', noteId)
          },
          ondragleave: function (event) {
          // remove the drop feedback style
            event.target.classList.remove('drop-target')
            event.relatedTarget.classList.remove('can-drop')
            self.$store.commit('updateDropOnNoteId', null)
          },
          ondrop: function (event) {
          },
          ondropdeactivate: function (event) {
          // remove active dropzone feedback
            event.target.classList.remove('drop-active')
            event.target.classList.remove('drop-target')
          }
        })
      }
    }
  },
  beforeDestroy () {
    interact(this.$el).unset()
  },
  mounted () {
    this.setListener(this.snapGrid)
  }
}
</script>

<style scoped>
.dragbase {
  position: absolute;
  box-sizing:border-box;
}

.drop-target {
  border: 2px dashed darkgrey;
}
</style>
